import { useCallback, useEffect, useState } from 'react'

import { useIsSearchBot } from '@/shared/lib/seo/bot/search-bot-context'

import { fetchIpInfo } from '../api/fetchIpInfo'
import { hasVpnNoticeCookie, setVpnNoticeCookie } from '../lib/vpnNoticeCookie'
import { RU_COUNTRY_ISO } from '../model/constants'

export const useVpnNotice = () => {
	const [isVisible, setIsVisible] = useState(false)
	const isSearchBot = useIsSearchBot()

	useEffect(() => {
		if (isSearchBot || hasVpnNoticeCookie()) {
			return
		}

		fetchIpInfo().then(iso => {
			if (!iso) {
				return
			}

			if (iso === RU_COUNTRY_ISO) {
				setVpnNoticeCookie()

				return
			}

			setIsVisible(true)
		})
	}, [isSearchBot])

	const handleDismiss = useCallback(() => {
		setVpnNoticeCookie()
		setIsVisible(false)
	}, [])

	return {
		isVisible,
		handleDismiss
	}
}
